.root .menu {
  min-width: var(--rc-theme-react-components-dropdown-menu-min-width);
  border-radius: var(--rc-theme-react-components-dropdown-menu-border-radius);
}

.root .menu .menu-item-icon {
  font-size: var(--rc-theme-font-size-text-lg);
}

.menu.position-at-click {
  min-width: var(--rc-theme-react-components-dropdown-menu-position-at-click-min-width);
}
